export const UPDATE_VERSION_HISTORY = 'versionHistory/UPDATE_VERSION_HISTORY';
export const CLEAR_VERSION_HISTORY = 'versionHistory/CLEAR_VERSION_HISTORY';
export const UPDATE_VERSION_HISTORY_ITEM = 'versionHistory/UPDATE_VERSION_HISTORY_ITEM';
export const UPDATE_VERSION_HISTORY_ITEM_LOADED_STATUS = 'versionHistory/UPDATE_VERSION_HISTORY_ITEM_LOADED_STATUS';
export const UPDATE_VERSION_HISTORY_ITEM_SAVING_STATUS = 'versionHistory/UPDATE_VERSION_HISTORY_ITEM_SAVING_STATUS';
export const UPDATE_VERSION_HISTORY_LATEST_SAVED_ITEM = 'versionHistory/UPDATE_VERSION_HISTORY_LATEST_SAVED_ITEM';
